<div class="social-buttons-container">
  <button
    class="social-buttons flex-center"
    (click)="googleLogin()"
    [class.social-buttons-theme-two]="theme() === GbTheme.ThemeTwo"
    [class.rounded-pill]="theme() === GbTheme.ThemeOne"
  >
    <span class="primary-font-medium">{{ 'authentication.continue_with' | translate }}</span>
    <img
      class="icons"
      [src]="s3BucketAssets() + '/global/web/common/google-icon.svg'"
      alt="google"
    />
  </button>

  <div class="d-none" id="googleAuthContainer"></div>

  <button
    class="social-buttons flex-center"
    (click)="appleLogin()"
    [class.social-buttons-theme-two]="theme() === GbTheme.ThemeTwo"
    [class.rounded-pill]="theme() === GbTheme.ThemeOne"
  >
    <span class="primary-font-medium">{{ 'authentication.continue_with' | translate }}</span>
    <img class="icons" [src]="s3BucketAssets() + '/global/web/common/apple-icon.svg'" alt="apple" />
  </button>
</div>
